<div class="modal-header w-100">
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body w-100 h-100">
    @if (!attribution) {
        <span class="w-100 h-100 spinner spinner-lg"></span>
    }
    <p class="pre-wrap w-100 h-100">{{ (attribution)?.sbom }}</p>
</div>

